/**
 * Roteiro e Diário (01/10/2026) — Administração › Roteiro.
 * `moduleId` = `system_modules.name` e a chave do `maintenance_modules.yaml`;
 * `basePath` = `system_modules.frontend_route`.
 */
import { lazy } from "react";

import { ModuleRoutes } from "../types";

const RoteiroPage = lazy(() => import("@/pages/admin/RoteiroPage"));

export const roteiroRoutes: ModuleRoutes = {
  moduleId: "roteiro",
  basePath: "/admin/roteiro",
  routes: [
    {
      path: "/admin/roteiro",
      element: <RoteiroPage />,
      permission: { resource: "roteiro", action: "ver" },
    },
  ],
};
